import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import { AiFillCloseSquare } from "react-icons/ai";
import { IoCalendar } from 'react-icons/io5';
import moment from 'moment';

var adbs = require("ad-bs-converter");

const HomeJacketModal = (props) => {
  const { open, data, itemIndex } = props;
  const [modalVisible, setModalVisible] = useState(open);
  let date = moment(data.created_at).format('yyyy/MM/DD');
  let convertedDate = adbs.ad2bs(date)

  useEffect(() => {
    setModalVisible(open)
  }, [open])

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    window.scrollTo(0, 0);

    return () => {
      document.body.style.overflow = 'unset'
    };
  }, []);

  const handleClose = () => {
    setModalVisible(false)
  }

  return (
    <Modal
      isOpen={modalVisible}
      contentLabel="Minimal Modal Example"
      className="jacket-modal"
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.38)'
        },
      }}
      onAfterClose={() => {
        if (itemIndex === 0) {
          document.body.style.overflow = 'unset'
        }
      }}
    >
      <div className='container'>
        <div className='title-wrapper'>
          <h3 className='ecn-title'>{data?.title}</h3>
          <AiFillCloseSquare
            onClick={handleClose}
            size={40}
            className='close-btn'
            color={'#092770'}
          />
        </div>
        <p className="text-13-primary display-flex align-item-center dev-number"><IoCalendar className="mr-05" />{`${convertedDate?.en?.year}/${convertedDate?.en?.month}/${convertedDate?.en?.day}`}</p>
        {data?.type === 'notice' ?
          <img
            src={data?.value}
            alt='Notice image'
          // style="width:100%;"
          />
          :
          <div>
            <div className="blog-details" dangerouslySetInnerHTML={{ __html: data?.value || '' }}>
            </div>
          </div>
        }

      </div>
    </Modal>
  )
}

export default HomeJacketModal
